//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';



export interface ParamsType {
    universe: string,
    body: {
        direction: string,
        id: number,
    },
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/promo-notifications/order -> post -> ${code}`);
    };
};

const Response200IO = t.number;
export type Response200Type = number;
export const decodeResponse200 = createGuard(200, Response200IO);

const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsChangeOrderPromoNotificationsRequest"
 */
export const openapi_website_cms_changeOrderPromoNotifications = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    const url = `${api_url}/website-cms/${params.universe}/promo-notifications/order`;
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.body,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsChangeOrderPromoNotificationsParamsType = ParamsType;

export type OpenapiWebsiteCmsChangeOrderPromoNotificationsResponseType = {
    status: 200,
    body: Response200Type,
} | {
    status: 500,
    body: Response500Type,
};

export type OpenapiWebsiteCmsChangeOrderPromoNotificationsResponse200Type = Response200Type;

export const openapiWebsiteCmsChangeOrderPromoNotificationsRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsChangeOrderPromoNotificationsResponseType> => {
    const response = await openapi_website_cms_changeOrderPromoNotifications(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    const parse = (body: string): {
        type: 'json',
        json: unknown,
    } | {
        type: 'text'
    } => {
        try {
            return {
                type: 'json',
                json: JSON.parse(body)
            };
        } catch (_err) {
            return {
                type: 'json',
                json: {},
            };
        }
    };
    const bodyParsed = parse(body);

    if (bodyParsed.type === 'text') {
        throw Error(`Http status ${status} - json was expected`);
    }

    
    if (status === 200) {
        return {
            status: 200,
            body: decodeResponse200(bodyParsed.json)
        };
    }


    if (status === 500) {
        return {
            status: 500,
            body: decodeResponse500(bodyParsed.json)
        };
    }

    throw new Error(`openapiWebsiteCmsChangeOrderPromoNotificationsRequest - unhandled response ${response.status}`);
};

